import RobustIcon from "../svg/LandingRobustIcon.svg"
const Icon = () => {
    return (
   
  <img src={RobustIcon} />


    )
  }
  export default Icon;